import { FC } from "react";

import LargeFooter from "./LargeFooter";
import SmallFooter from "./SmallFooter";

const Footer: FC = () => {
  return (
    <>
      <LargeFooter className="hidden phone:block" />
      <SmallFooter className="phone:hidden" />
    </>
  );
};

export default Footer;
